module.exports = __webpack_public_path__ + "assets/img/img-feature2-0baf8265.jpg";